import {
  inboundShipmentIdFormat,
  purchaseOrderIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const unlinkShipmentFromPurchaseOrder = {
  name: "unlinkShipmentFromPurchaseOrder" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    inboundShipmentId: inboundShipmentIdFormat.schema,
  }),
  output: z.object({ success: z.boolean() }),
};
